// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal__earningrules {
  display: flex;
  flex-direction: row;
}
.modal__earningrules .dashboard__customFormBox {
  display: flex;
  flex-direction: column;
  margin: 0 0 1.5rem;
}
.modal__earningrules .dashboard__customFormCard {
  display: flex;
  flex-direction: column;
  background-color: #fafafa;
  border: 0.1rem solid #d2d3d3;
  border-radius: 0.375rem;
}
.modal__earningrules .dashboard__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: -0.05rem -0.05rem 0;
}
.modal__earningrules .dashboard__top .dashboard__left {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.modal__earningrules .dashboard__left button, .modal__earningrules .dashboard__right button {
  font-size: 0.7rem;
  font-weight: 700;
  line-height: 1.5;
  padding: 0.5rem 2rem;
  border-radius: 0;
  text-transform: uppercase;
  margin-left: -0.05rem;
}
.modal__earningrules .dashboard__left button:first-child {
  border-top-left-radius: 0.375rem;
}
.modal__earningrules .dashboard__right button:last-child {
  border-top-right-radius: 0.375rem;
}
.modal__earningrules .dashboard__right button i {
  margin-right: 0.25rem;
}
.modal__earningrules .dashboard__top .dashboard__right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.modal__earningrules .dashboard__middle {
  display: flex;
  flex-direction: column;
  padding: 1rem;
}
.modal__earningrules .button-section {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.modal__earningrules .button-section button:first-child {
  margin-right: 10px;
}

.dashboard__transactionsModal .customForm .form-group.withSwitch {
  display: flex;
  flex-direction: row;
  margin: 0;
  margin-left: -0.75rem;
  margin-bottom: 0.75rem;
}
.dashboard__transactionsModal .customForm .form-group.withSwitch label {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 0;
}
.dashboard__transactionsModal .customForm .form-group.withSwitch label .react-switch {
  margin-left: 1rem;
}

.dashboard__headingBackLink2 a {
  display: inline-block;
  border-radius: 30px;
  width: 80px;
  height: 30px;
  background-color: #FFF;
  line-height: 30px;
  text-align: center;
  color: #000;
  margin-bottom: 10px;
}
.dashboard__headingBackLink2 img {
  width: 20px;
  margin-left: -2px;
  margin-right: 5px;
  margin-top: -2px;
}`, "",{"version":3,"sources":["webpack://./src/styles/usermodal.scss"],"names":[],"mappings":"AA+BA;EAEC,aAAA;EACA,mBAAA;AA/BD;AAiCI;EAA0B,aAAA;EAAc,sBAAA;EAAuB,kBAAA;AA5BnE;AA6BI;EAA2B,aAAA;EAAc,sBAAA;EAAuB,yBAAA;EAA0B,4BAAA;EAA6B,uBAAA;AAtB3H;AAuBI;EAAgB,aAAA;EAAc,mBAAA;EAAoB,8BAAA;EAA+B,2BAAA;AAjBrF;AAkBI;EAAiC,aAAA;EAAc,mBAAA;EAAoB,2BAAA;AAbvE;AAcI;EAAiD,iBAAA;EAAkB,gBAAA;EAAiB,gBAAA;EAAiB,oBAAA;EAAqB,gBAAA;EAAiB,yBAAA;EAA0B,qBAAA;AALzK;AAMI;EAAoC,gCAAA;AAHxC;AAII;EAAoC,iCAAA;AADxC;AAEI;EAA2B,qBAAA;AAC/B;AAAI;EAAkC,aAAA;EAAc,mBAAA;EAAoB,yBAAA;AAKxE;AAJI;EAAmB,aAAA;EAAc,sBAAA;EAAuB,aAAA;AAS5D;AARI;EAAgB,aAAA;EAAc,mBAAA;EAAoB,yBAAA;AAatD;AAZI;EAAmC,kBAAA;AAevC;;AAVQ;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,qBAAA;EACA,sBAAA;AAaZ;AAXY;EACI,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,SAAA;AAahB;AAXgB;EACI,iBAAA;AAapB;;AALI;EAAE,qBAAA;EAAsB,mBAAA;EAAoB,WAAA;EAAY,YAAA;EAAa,sBAAA;EAAuB,iBAAA;EAAkB,kBAAA;EAAmB,WAAA;EAAY,mBAAA;AAiBjJ;AAhBI;EAAI,WAAA;EAAY,iBAAA;EAAkB,iBAAA;EAAkB,gBAAA;AAsBxD","sourcesContent":["///* ----------- Default Styling Start --------------- */\r\n\r\n$primary-fontFamily: \"Montserrat\", sans-serif;\r\n$primary-fontWeight: 400;\r\n$primary-lineHeight: 1.4;\r\n$primary-fontColor: #6e6b7b;\r\n$primary-color: #2056a5;\r\n$primary-hover: #1b427c;\r\n$primary-bgColor: #fafafa;\r\n$color-black: #000000;\r\n$color-white: #ffffff;\r\n\r\n/// Viewport\r\n$desktop_xxxl: 1920px;\r\n$desktop_xxl: 1650px;\r\n$desktop_xl: 1440px;\r\n$laptop: 1366px;\r\n$desktop: 1280px;\r\n$desktopSmall: 1024px;\r\n$tabletSmall: 768px;\r\n$mobileBig: 767px;\r\n$mobile: 480px;\r\n$mobileSmall: 360px;\r\n\r\n/// Progressbar Color & Speed\r\n$progressbar-color1: #4071eb;\r\n$progressbar-color2: #56cfeb;\r\n$progressbar-speed: 2.5s;\r\n\r\n///* ----------- Default Styling End ----------------- */\r\n\r\n.modal__earningrules {\r\n    $modal__earningrules: \".modal__earningrules\";\r\n\tdisplay: flex;\r\n\tflex-direction: row;\r\n\r\n    .dashboard__customFormBox{display: flex;flex-direction: column;margin: 0 0 1.5rem;}\r\n    .dashboard__customFormCard{display: flex;flex-direction: column;background-color: #fafafa;border: 0.1rem solid #d2d3d3;border-radius: 0.375rem;}\r\n    .dashboard__top{display: flex;align-items: center;justify-content: space-between;margin: -0.05rem -0.05rem 0;}\r\n    .dashboard__top .dashboard__left{display: flex;align-items: center;justify-content: flex-start;}\r\n    .dashboard__left button,.dashboard__right button{font-size: 0.7rem;font-weight: 700;line-height: 1.5;padding: 0.5rem 2rem;border-radius: 0;text-transform: uppercase;margin-left: -0.05rem;}\r\n    .dashboard__left button:first-child{border-top-left-radius: 0.375rem;}\r\n    .dashboard__right button:last-child{border-top-right-radius: 0.375rem;}\r\n    .dashboard__right button i{margin-right: 0.25rem;}\r\n    .dashboard__top .dashboard__right{display: flex;align-items: center;justify-content: flex-end;}\r\n    .dashboard__middle{display: flex;flex-direction: column;padding: 1rem;}\r\n    .button-section{display: flex;align-items: center;justify-content: flex-end;}\r\n    .button-section button:first-child{margin-right: 10px;}\r\n}\r\n\r\n.dashboard__transactionsModal{\r\n    .customForm{\r\n        .form-group.withSwitch{\r\n            display: flex;\r\n            flex-direction: row;\r\n            margin: 0;\r\n            margin-left: -0.75rem;\r\n            margin-bottom: 0.75rem;\r\n\r\n            label{\r\n                display: flex;\r\n                align-items: center;\r\n                justify-content: flex-start;\r\n                margin: 0;\r\n\r\n                .react-switch {\r\n                    margin-left: 1rem;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.dashboard__headingBackLink2{\r\n    a{display: inline-block;border-radius: 30px;width: 80px;height: 30px;background-color: #FFF;line-height: 30px;text-align: center;color: #000;margin-bottom: 10px;}\r\n    img{width: 20px;margin-left: -2px;margin-right: 5px;margin-top: -2px;}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
